import React, { ChangeEvent, CSSProperties, useRef, useState } from 'react'
import { ParentDataType } from '../../containers/ProfileParentsPage/types'

// Styles
import './styles.scss'

// Icons
import IconEdit from './images/iconEdit'
import IconCancel from './images/iconCancel'

export default ({
  icon,
  title,
  parentData,
  onUpload,
  onRemove,
  colorButton,
  colorIconEdit,
  style,
  editIsHidden,
}: {
  icon: JSX.Element
  title: string
  parentData: ParentDataType
  onUpload: (parent_id: string, file: File) => void
  onRemove: (parent_id: string) => void
  colorButton?: string
  colorIconEdit?: string
  style?: CSSProperties
  editIsHidden?: boolean
}) => {
  const [isEdit, setIsEdit] = useState<boolean>(false)

  const refFile = useRef<HTMLInputElement | null>(null)

  const avatar = parentData
    ? parentData.short_id
      ? parentData.avatar_url
      : parentData.photo?.url
    : false

  const handleImagePicker = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0] && parentData) {
      const photo = event.target.files[0]
      onUpload(parentData.profile_id, photo)
      setIsEdit(false)
      if (refFile.current) {
        refFile.current.value = ''
      }
    }
  }

  return (
    <div className={'parent-avatar'} style={style}>
      <div className={'parent-avatar__photo'}>
        {avatar ? <img src={avatar} /> : icon}
      </div>
      {isEdit ? (
        <div className={'parent-avatar__column'}>
          <div
            className={'parent-avatar__button'}
            style={{ background: colorButton }}
            onClick={() => refFile.current?.click()}
          >
            Загрузить фото
          </div>
          {parentData && parentData.photo?.url ? (
            <div
              className={'parent-avatar__button'}
              style={{ background: colorButton }}
              onClick={() => {
                if (parentData) {
                  onRemove(parentData.profile_id)
                }
              }}
            >
              Удалить фото
            </div>
          ) : null}
        </div>
      ) : (
        <div className={'parent-avatar__name'}>{title}</div>
      )}
      {editIsHidden ? (
        <div style={{ width: 48 }} />
      ) : isEdit ? (
        <IconCancel
          className={'parent-avatar__edit'}
          onClick={() => setIsEdit(false)}
        />
      ) : (
        <IconEdit
          className={'parent-avatar__edit'}
          color={colorIconEdit || '#1978B2'}
          onClick={() => setIsEdit(true)}
        />
      )}
      <input type="file" ref={refFile} onChange={handleImagePicker} />
    </div>
  )
}
